import React from 'react'
import '../style/ambiente.css'

export const Ambiente = () => {
  return (process.env.REACT_APP_AMBIENTE == 'PRO') ||
    <div className='ambiente'>
        <span>{ process.env.REACT_APP_AMBIENTE }</span>
    </div>
}
